import React from 'react';

declare const gsap: any;

import CompareCollapse from '../../../2_Molecules/Collapse/CompareCollapse';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import ReactHtmlParser from 'react-html-parser';

interface SpecificationItem {
  Title: string;
  Data: string;
  type?: string;
}

interface SpecificationCategory {
  [categoryName: string]: SpecificationItem[];
}

interface TrimType {
  name: string;
  url_slug: string;
}

interface Trim {
  trim_type: TrimType;
  visual: any;
}

interface Carline {
  title: string;
  url_slug: string;
}

interface Year {
  title: string;
}

interface VehicleData {
  trim: Trim;
  model_code: string;
  option_code: string;
  carline: Carline;
  year: Year;
  specifications?: SpecificationCategory;
}

interface ModelData {
  [trimSlug: string]: VehicleData;
}

interface TrimSpecAccordionsProps {
  modelData: ModelData;
  trimsOrder: string[];
  activeSlide: number;
}

const getTableDataCellValue = (
  trimData: SpecificationCategory | undefined,
  category: string,
  name: string,
  index: number
): SpecificationItem | null => {
  try {
    const categoryData = trimData?.[category];

    if (categoryData) {
      // DEPRECATED! Do not use the "NAME" anymore as we have some data that have twice the same name "AWD"
      // return categoryData.find(item => item.Title === name);
      return categoryData.at(index) || null;
    }

    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
};

const generateTableRow = (name: string, values: string[], isHeaderCell: boolean, catCount: number): JSX.Element => {
  if (isHeaderCell) {
    return (
      <tr role="row" className={`compare_body mz-table-content ${catCount === 1 ? '' : ''}`} data-row-target={'row_' + catCount} key={`header-${name}-${catCount}`}>
        <td className="mz-table-left" role="cell">
          {ReactHtmlParser(name)}
        </td>
      </tr>
    );
  } else {
    return (
      <React.Fragment key={`row-${name}-${catCount}`}>
        <tr role="row" className={`mz-table-mobile mz-table-content ${catCount === 1 ? '' : ''}`} data-row-target={'row_' + catCount}>
          <td role="cell">
            {ReactHtmlParser(name)}
          </td>
        </tr>
        <tr className={`mz-table-content ${catCount === 1 ? '' : ''}`} data-row-target={'row_' + catCount}>
          <td className="mz-table-left mz-table-310 mz-table-tablet-200 mz-table-mobile-150 ">{ReactHtmlParser(name)}</td> 
          {values.map((value, index) => {
            if (index === 0) {
              return (<td key={`${name}-${index}`} className="mz-table-col--selected text--center mz-table-250 mz-table-tablet-150 mz-table-mobile-150">{ReactHtmlParser(value)}</td>);
            } else {
              return (<td key={`${name}-${index}`} className="text--center mz-table-250 mz-table-tablet-150 mz-table-mobile-150">{ReactHtmlParser(value)}</td>);
            }
          })}
        </tr>
      </React.Fragment>
    );
  }
};

function triggerAccordion(e: React.MouseEvent<HTMLButtonElement>) {
  const target = e.target as HTMLButtonElement;
  const isExpanded = target.classList.contains('active');
  const table = target.closest('table');
  
  if (!table) return;
  
  const rowList = table.querySelectorAll<HTMLElement>('[data-row-target]');
  rowList.forEach((current) => {
    current.classList.remove('active');
  });
  
  const buttonList = table.querySelectorAll<HTMLButtonElement>('button');
  buttonList.forEach((current) => {
    current.classList.remove('active');
  });

  if (!isExpanded) {
    target.classList.add('active');
    const closestTr = target.closest('tr');
    if (closestTr) {
      const targetId = closestTr.getAttribute('id');
      const activeRowList = table.querySelectorAll<HTMLElement>(`[data-row-target="${targetId}"]`);
      activeRowList.forEach((current) => {
        current.classList.add('active');
        const thead = table.querySelector('thead');
        if (thead && typeof gsap !== 'undefined') {
          gsap.to(target.closest('.mz-table-container'), {
            delay: .5,
            duration: .5,
            scrollTo: { x: 0, y: target, offsetY: thead.clientHeight + 10 }
          });
        }
        document.body.scrollTo(0, 0);
      });
    }
  }
}

const TrimSpecAccordions: React.FC<TrimSpecAccordionsProps> = ({ modelData, trimsOrder, activeSlide }) => {
  const currentMQ = useMediaQuery();
  const isMobile = ['xs', 'sm'].includes(currentMQ || '');

  const firstColumnData = isMobile ? modelData[trimsOrder[activeSlide]] : modelData[trimsOrder[0]];
  const firstColumnSpecData = firstColumnData?.specifications;

  let catCount = 0;

  const generateTableAccordions = (categoryName: string, categoryData: SpecificationItem[]): JSX.Element => {
    catCount++;

    // Generate the table rows of the category.
    const tableRows = categoryData.map((item, itemIndex) => {
      let tabelData = [item.Data];

      // Get the all the data-cell values in the row.
      trimsOrder.forEach((trimCode, index) => {
        if (index !== 0) {
          const trimData = modelData[trimCode]?.specifications;
          const trimRowData = getTableDataCellValue(trimData, categoryName, item.Title, itemIndex);

          if (trimRowData && trimRowData.Data) {
            tabelData = [...tabelData, trimRowData.Data];
          }
        }
      });

      const isHeaderCell = !!(item.type && item.type.toLowerCase() === 'header');
      console.log(item.Title);
      return generateTableRow(item.Title, tabelData, isHeaderCell, catCount);
    });

    return (
      <CompareCollapse
        key={categoryName}
        id={catCount}
        isActive={false}
        onClick={triggerAccordion}
        buttonContent={(<h6>{ReactHtmlParser(categoryName)}</h6>)}
      >
        {tableRows}
      </CompareCollapse>
    );
  };

  return (
    <tbody className="mz-trim-spec-accordions">
      {
        (firstColumnData && firstColumnSpecData) && (
          Object.keys(firstColumnSpecData).map(categoryName => {
            return generateTableAccordions(categoryName, firstColumnSpecData[categoryName]);
          })
        )
      }
    </tbody>
  );
};

export default TrimSpecAccordions;